<p-toast position="top-right" key="msj"></p-toast>
<p-confirmDialog [style]="{width: '25vw'}" [baseZIndex]="10000" acceptLabel="SI" rejectLabel="NO"
    rejectButtonStyleClass="p-button-text" styleClass="dark-confirm"></p-confirmDialog>
<p-confirmDialog [style]="{width: '25vw'}" key="sinInformacionDialog" [baseZIndex]="10000" acceptLabel="Aceptar"
    rejectLabel="Cancelar" rejectButtonStyleClass="p-button-text" styleClass="color-confirmar dark-confirm"
    [rejectVisible]="false"></p-confirmDialog>
<div class="d-flex justify-content-center">
    <div class="container-fluid" style="width: 90%;">
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card card-shadow sinborde">
                    <div class="card-header sinborde" style="background: none;">
                        <div class="cardicono rounded">
                            <i class="pi pi-car" style="color: #fff;"></i>
                        </div>
                        <header class="posicion" style="left: 6%; top: 0%;">Combustibles</header>
                    </div>
                    <div class="card-content">
                        <div class="row mt-3">
                            <p-table #dt1 [value]="impcombustible" [tableStyle]="{'min-width': '50rem'}" styleClass="p-datatable-sm p-datatable-striped"
                                dataKey="id_config_unidad" [rows]="15" 
                                [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [resizableColumns]="false"
                                [paginator]="true" responsiveLayout="scroll" 
                                currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} registros"
                                [globalFilterFields]="['id_config_unidad', 'des_tipoconfiguracionunidad', 'km_inicial', 'km_final', 'imp_sueldodriver', 'imp_sueldoaux', 'imp_prestacionesrhdiario', 'imp_mantenimientodiario', 'imp_monitoreodiario', 'imp_operaciones', 'imp_depreciacion', 'clv_activo']">
                                <ng-template pTemplate="header">
                                    <tr [ngClass]="{'texto_sm':true}">
                                        <th>#</th>
                                        <th style="min-width: 10rem">Descripción</th>
                                        <th style="min-width: 15rem">Importe</th>
                                        <th></th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-data let-index="rowIndex">
                                    <tr>
                                        <td>
                                            <div class="texto_negrita">{{(index + 1)}}</div>
                                        </td>
                                        <td>
                                            <div class="texto_negrita">
                                                <i class="pi pi-car" style="margin-right: 5px;"></i>{{data.des_tipodecombustible}}
                                            </div>
                                        </td>    
                                        <td>
                                            <div class="texto_negrita">
                                                <i class="pi pi-money-bill" style="margin-right: 5px;"></i> {{data.imp_combustible | currency}}
                                            </div>
                                        </td>   
                                        <td style="width: 130px;">
                                            <div class="d-flex justify-content-around">
                                                <button class="btn btn-warning" pTooltip="Editar Informacion"
                                                    tooltipPosition="left" (click)="mostrarModalEditar(data,1);">
                                                    <i class="pi pi-pencil"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="emptymessage">
                                    <tr>
                                        <td colspan="13">No se encontró ningún registro.</td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <p-dialog [(visible)]="dspimpcombustible" styleClass="dark-dialog" [resizable]="false" [draggable]="false" [style]="{width: '50vw'}">
        <ng-template pTemplate="header">
            <h3>{{ texto_operacion }}</h3> 
        </ng-template>
        <ng-template pTemplate="content">
            <form [formGroup]="impCombustibleForm" (ngSubmit)="guardarInformacion()">
                <div class="row">
                    <div class="col-md-4 form-group">
                        <label for="km_final">Importe</label>
                        <input type="number" id="imp_combustible" formControlName="imp_combustible" class="form-control">
                    </div>
                </div>
            </form>
        </ng-template>
        <ng-template pTemplate="footer">
            <div style="display: flex; justify-content: flex-end; gap: 10px;">
                <button pButton label="Guardar" icon="pi pi-save" (click)="guardarInformacion()"></button>
                <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="cancelarVentanaModal()"></button>
            </div>
        </ng-template>
    </p-dialog>
</div>

